import React from 'react';
import PropTypes from "prop-types";
export var EuiHeaderSectionsProp = () => <div />;
EuiHeaderSectionsProp.propTypes = {
  /**
     * An arry of items that will be wrapped in a #EuiHeaderSectionItem
     */
  items: PropTypes.arrayOf(PropTypes.node.isRequired),
  /**
     * Apply the passed border side to each #EuiHeaderSectionItem
     */
  borders: PropTypes.oneOf(["left", "right", "none"]),
  /**
     * Breadcrumbs in the header cannot be wrapped in a #EuiHeaderSection in order for truncation to work.
     * Simply pass the array of EuiBreadcrumb objects
     */
  breadcrumbs: PropTypes.arrayOf(PropTypes.any.isRequired),
  /**
     * Other props to pass to #EuiHeaderBreadcrumbs
     */
  breadcrumbProps: PropTypes.any
};
try {
  EuiHeaderSectionsProp.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/header/props.tsx',
    description: '',
    displayName: 'EuiHeaderSectionsProp',
    methods: [],
    props: {
      items: {
        defaultValue: null,
        description: 'An arry of items that will be wrapped in a #EuiHeaderSectionItem',
        name: 'items',
        parent: {
          fileName: 'app/src/components/header/header.tsx',
          name: 'EuiHeaderSections'
        },
        declarations: [{
          fileName: 'app/src/components/header/header.tsx',
          name: 'EuiHeaderSections'
        }],
        required: false,
        type: {
          name: 'ReactNode[]'
        }
      },
      borders: {
        defaultValue: null,
        description: 'Apply the passed border side to each #EuiHeaderSectionItem',
        name: 'borders',
        parent: {
          fileName: 'app/src/components/header/header.tsx',
          name: 'EuiHeaderSections'
        },
        declarations: [{
          fileName: 'app/src/components/header/header.tsx',
          name: 'EuiHeaderSections'
        }],
        required: false,
        type: {
          name: 'enum',
          raw: 'Border',
          value: [{
            value: '"left"'
          }, {
            value: '"right"'
          }, {
            value: '"none"'
          }]
        }
      },
      breadcrumbs: {
        defaultValue: null,
        description: 'Breadcrumbs in the header cannot be wrapped in a #EuiHeaderSection in order for truncation to work.\n' + 'Simply pass the array of EuiBreadcrumb objects',
        name: 'breadcrumbs',
        parent: {
          fileName: 'app/src/components/header/header.tsx',
          name: 'EuiHeaderSections'
        },
        declarations: [{
          fileName: 'app/src/components/header/header.tsx',
          name: 'EuiHeaderSections'
        }],
        required: false,
        type: {
          name: 'EuiBreadcrumbProps[]'
        }
      },
      breadcrumbProps: {
        defaultValue: null,
        description: 'Other props to pass to #EuiHeaderBreadcrumbs',
        name: 'breadcrumbProps',
        parent: {
          fileName: 'app/src/components/header/header.tsx',
          name: 'EuiHeaderSections'
        },
        declarations: [{
          fileName: 'app/src/components/header/header.tsx',
          name: 'EuiHeaderSections'
        }],
        required: false,
        type: {
          name: 'Omit<EuiBreadcrumbsProps, "breadcrumbs">'
        }
      }
    },
    extendedInterfaces: ['EuiHeaderSections']
  };
} catch (e) {}